import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileHeaderComponent } from './mobile-header/mobile-header.component';
import { ConfirmationComponent, IconComponent } from 'ui-kit';
import { MobileMainMenuModule } from '../main-menu/mobile/mobile-main-menu.module';



@NgModule({
	declarations: [
		MobileHeaderComponent
	],
	exports: [
		MobileHeaderComponent
	],
  imports: [
    CommonModule,
    IconComponent,
    ConfirmationComponent,
    MobileMainMenuModule
  ]
})
export class MobileModule { }
